import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const LocationFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.666 2.35016L3.54827 4.54347C1.4875 5.42666 0.457112 5.86825 0.501367 6.53839C0.545621 7.20853 1.62512 7.5108 3.78414 8.11532L6.98769 9.01231L7.88468 12.2159C8.4892 14.3749 8.79147 15.4544 9.46161 15.4986C10.1317 15.5429 10.5733 14.5125 11.4565 12.4517L13.6498 7.334C15.2332 3.63944 16.0249 1.79216 15.1164 0.883619C14.2078 -0.0249188 12.3606 0.766773 8.666 2.35016Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const LocationFilledSize16 = hoc(forwardRef(LocationFilledSize16Component), 'LocationFilledSize16');

export { LocationFilledSize16 as default };
//# sourceMappingURL=LocationFilledSize16.js.map
